import PropTypes from 'prop-types';

export const SectionContentPropTypes = {
  data: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  initialFormValues: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isSaving: PropTypes.bool.isRequired,
  isNewRecord: PropTypes.bool.isRequired,
  recordId: PropTypes.string,
  setForm: PropTypes.func.isRequired,
  setInForm: PropTypes.func.isRequired,
  setMultipleInForm: PropTypes.func.isRequired,
  setIsLoading: PropTypes.func.isRequired,
  setRecordConfig: PropTypes.func.isRequired,
  validateField: PropTypes.func.isRequired,
  validationErrors: PropTypes.object.isRequired,
  schema: PropTypes.object.isRequired,
  setSchema: PropTypes.func.isRequired,
  staticValidateField: PropTypes.func.isRequired,
  isOwnersClicked: PropTypes.bool.isRequired,
  allDeletedRecords: PropTypes.array.isRequired,
  entitiesSideData: PropTypes.object.isRequired,
  initialEntitiesSideData: PropTypes.object.isRequired,
  setEntitiesSideData: PropTypes.func.isRequired,
  setInitialEntitiesSideData: PropTypes.func.isRequired,
};
